// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ProjectLossReason {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly isSystem: boolean;
  readonly priority: number;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.description = data.description === undefined ? '' : data.description;
    this.isSystem = data.isSystem === undefined ? false : data.isSystem;
    this.priority = data.priority === undefined ? 0 : data.priority;
  }

  static zero(): ProjectLossReason {
    const zeroValues: ExcludeMethodsDeep<ProjectLossReason> = {
      id: NIL_UUID,
      name: '',
      description: '',
      isSystem: false,
      priority: 0,
    };
    return new ProjectLossReason(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectLossReasonWireFormat = {
  id: string;
  name: string;
  description: string;
  isSystem: boolean;
  priority: number;
};

type NewProjectLossReasonProps = PartialDeep<ProjectLossReason, { recurseIntoArrays: true }>;
export const NewProjectLossReason: (props: NewProjectLossReasonProps) => ProjectLossReason = (
  props,
) => new ProjectLossReason(props);

type NewProjectLossReasonFromWireFormatProps = PartialDeep<
  ProjectLossReasonWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectLossReasonFromWireFormat: (
  props: NewProjectLossReasonFromWireFormatProps,
) => ProjectLossReason = (props) => new ProjectLossReason(props);
